export function AnimatedBackground() {
  return (
    <div className="absolute inset-0 overflow-hidden">      
      {/* Lighter blue overlay for text readability */}
      <div className="absolute inset-0 bg-blue-900/40" />
    </div>
  );
}